/// <reference path="../_references.ts"/>

module App.Administrative.Inventory {
	import TitleBarService = App.Helpers.TitleBarService;
	import ServiceRequest = App.Appointments.ServiceRequest;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import Appointment = App.Appointments.Appointment;
	import UserSession = App.User.UserSession;
	import User = App.User.User;
	import OfficeService = App.Utils.OfficeService;

	export class InventorySummaryController {

		static $inject: string[] = ['$scope', '$state' ,'TitleBarService', 'SelectedAppointment', 'InventoryService', '$q', 'UserSession', 'OfficeService'];

		serviceRequest: ServiceRequest = null;
		invReplenishments: InventoryReplenishment[] = null;
		warehouses: Warehouse[] = null;
		user: User;

		totalCost: number = null;
		selectedWarehouse: Warehouse = null;
		confirmSelected: boolean = false;

		standalone: boolean = false;

		constructor(
			private $scope: ng.IScope,
			private $state: ng.ui.IStateService,
			private TitleBarService: TitleBarService,
			private SelectedAppointment: SelectedAppointment,
			private InventoryService: InventoryService,
			private $q: ng.IQService,
			private UserSession: UserSession,
			private OfficeService: OfficeService
		) {
			TitleBarService.set('Appointment');

			UserSession.getUser().then((user) => {
				this.user = user;
				this.getWarehouses();
			});

			this.standalone = Boolean($state.params.standalone);

			OfficeService.getAppointment().then(response => {
				this.setServiceRequest(response.data);
			})
			.catch(() => {
				SelectedAppointment.getAppointment().then((appointment) => {
					this.setServiceRequest(appointment);
				}).catch((response) => {
					if (response === SelectedAppointment.NO_APPOINTMENT) {
						this.setReplenishmentsWithoutAppointment();
					}
					// TODO: Display an error?
				});
			});
		}

		getTitle(): string {
			return this.standalone
				? 'Inventory'
				: 'Inventory Summary';
		}

		deleteInventoryReplenishment(invReplenishmentId: number) {
			const vm = this;

			this.InventoryService.deleteInventoryReplenishment(invReplenishmentId).then((response) => {
				vm.invReplenishments.splice(vm.invReplenishments.findIndex((item) => response.data.id == item.id), 1);
				vm.totalCost = vm.calculateTotal(vm.invReplenishments);
			});
		}

		getWarehouses() {
			this.InventoryService.getWarehouses().then((response) => {
				this.warehouses = response.data;
				this.selectedWarehouse = this.warehouses.find(x => {
					return x.user.id === this.user.id;
				});
			});
		}

		getReplenishmentList(){
			const vm = this;

			vm.invReplenishments = [];

			let promises: ng.IPromise<ng.IHttpResponse<InventoryReplenishment[]>>[] = [];
			vm.serviceRequest.appointments.forEach((appointment) => {
				promises.push(vm.InventoryService.getInventoryReplenishment(appointment.id))
			});
			vm.$q.all(promises).then((response) => {
				response.forEach((list) => {
					vm.invReplenishments = vm.invReplenishments.concat(list.data);
				});
				vm.totalCost = vm.calculateTotal(vm.invReplenishments);
			});
		}

		calculateTotal(invReplenishments: InventoryReplenishment[]) {
			let total = 0;
			invReplenishments.forEach((invReplenishment) => {
				total += invReplenishment.total;
			});
			return total;
		}

		setServiceRequest(appointment: Appointment): void {
			this.InventoryService.getServiceRequest(appointment.service_request.id).then((response) => {
				this.serviceRequest = response.data;
				this.getReplenishmentList();
			});
		}

		setReplenishmentsWithoutAppointment(){
			this.InventoryService.getAllInventoryReplenishments().then((response) => {
				this.invReplenishments = response.data;
			})
		}

		displayDate(date: string) {
			return moment(date).format('MM/DD/YYYY h:mma');
		}

		toggleSelectInventory() {
			this.$state.go('.select', { selectedWarehouse: this.selectedWarehouse });
		}
	}
}